function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var RailsDatePicker = function RailsDatePicker(props) {
  var initialDate = props.initialDate,
      fieldName = props.fieldName;
  var cleaned_fieldName = fieldName.replace('[', '_').replace(']', '_');
  var hidden_field_id = cleaned_fieldName + '_hidden'; // Parse initial date from string (YYYY-MM-DD) to Date object without timezone issues

  var parseDateString = function parseDateString(dateString) {
    var parts = dateString.split('-');

    if (parts.length === 3) {
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1; // Month is 0-indexed

      var day = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }

    return new Date();
  }; // Function to format date to YYYY-MM-DD without timezone issues


  var formatDateForRails = function formatDateForRails(date) {
    if (!date) return '';
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  }; // Parse initial date from string (YYYY-MM-DD) to Date object


  var getInitialDate = function getInitialDate() {
    if (initialDate && initialDate.trim() !== '') {
      return parseDateString(initialDate);
    }

    return null; // No default date for fieldName
  };

  var _React$useState = React.useState(getInitialDate),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedDate = _React$useState2[0],
      setSelectedDate = _React$useState2[1];

  var handleDateChange = function handleDateChange(date) {
    setSelectedDate(date); // Update hidden field for Rails form submission

    var hiddenField = document.getElementById(hidden_field_id);

    if (hiddenField) {
      hiddenField.value = formatDateForRails(date);
    }
  }; // Initialize hidden field value on mount


  React.useEffect(function () {
    var hiddenField = document.getElementById(hidden_field_id);

    if (hiddenField) {
      hiddenField.value = formatDateForRails(selectedDate);
    }
  }, [selectedDate]); // Forzar ancho completo del datepicker después del render

  React.useEffect(function () {
    var applyStyles = function applyStyles() {
      var wrapper = document.querySelector('.' + cleaned_fieldName + '-picker-wrapper');
      var datepickerWrapper = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.react-datepicker-wrapper');
      var inputContainer = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.react-datepicker__input-container');
      var input = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('input.form-control');

      if (wrapper) {
        wrapper.style.width = '100%';
        wrapper.style.display = 'block';
        wrapper.style.maxWidth = '100%';
      }

      if (datepickerWrapper) {
        datepickerWrapper.style.width = '100%';
        datepickerWrapper.style.display = 'block';
        datepickerWrapper.style.maxWidth = '100%';
      }

      if (inputContainer) {
        inputContainer.style.width = '100%';
        inputContainer.style.display = 'block';
        inputContainer.style.maxWidth = '100%';
      }

      if (input) {
        input.style.width = '100%';
        input.style.display = 'block';
        input.style.maxWidth = '100%';
      }
    }; // Aplicar inmediatamente


    applyStyles(); // Aplicar después de un pequeño delay para asegurar que react-datepicker haya terminado

    setTimeout(applyStyles, 0);
    setTimeout(applyStyles, 100);
  }, [selectedDate]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    id: hidden_field_id,
    name: fieldName,
    value: formatDateForRails(selectedDate)
  }), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: selectedDate,
    onChange: handleDateChange,
    wrapperClassName: cleaned_fieldName + '-picker-wrapper',
    placeholderText: "Seleccione fecha"
  }));
};

export default RailsDatePicker;